import pick from 'lodash/pick';
import { vueEnv } from '@/globals';
import initSegment from '@/lib/segment';
import { inPortal } from '@/filters/helpers';

export const initAppAnalytics = () => {
  const segmentKey = vueEnv('segment_key');
  initSegment(segmentKey);
};

export const identify = (user) => {
  if (!user || user.sudo || !window.analytics) return false;

  const analyticsData = prepareAnalyticsData(user);
  const userId = user.id || user.email;
  
  const integrations = user.analytics_integrations || {};
  return analytics.identify(userId, analyticsData, { integrations });
};

export const trackEvent = (eventName, eventData = {}) => {
  const options = {};

  if (window.analytics) {
    analytics.track(eventName, eventData, options);
  }
};

const prepareAnalyticsData = (user) => {
  const getCompanyInfo = () => {
    return ['id', 'name', 'plan', 'created_at'].reduce((acc, key) => {
      acc[key] = user['org_' + key];
      return acc;
    }, {});
  };

  const getFullName = () => {
    return [user.first_name, user.last_name].join(' ');
  };

  let data = pick(user, [
    'group_type',
    'email',
    'org_id',
    'org_domain',
    'org_name',
    'aid',
    'sudo',
  ]);
  return Object.assign(data, {
    firstName: user.first_name,
    lastName: user.last_name,
    name: getFullName(),
    phone: user.mobile,
    mobile: user.mobile,
    username: getFullName(),
    company: getCompanyInfo(),
    last_web_session: Math.floor(Date.now() / 1000),
  });
};